import axios from "axios";
var cityDatalist = [
	{
		id: 1,
		name: "北京",
		code: 110100,
	},
	{
		id: 2,
		name: "上海",
		code: 310000,
	},
	{
		id: 3,
		name: "南京",
		code: 320100,
	},
	{
		id: 4,
		name: "常州",
		code: 320400,
	},
	{
		id: 5,
		name: "杭州",
		code: 330100,
	},
	{
		id: 6,
		name: "济南",
		code: 370100,
	},
	{
		id: 7,
		name: "青岛",
		code: 370200,
	},
	{
		id: 8,
		name: "长春",
		code: 220100,
	},
	{
		id: 9,
		name: "大连",
		code: 210200,
	},
	{
		id: 10,
		name: "天津",
		code: 120100,
	},
	{
		id: 11,
		name: "西安",
		code: 610100,
	},
	{
		id: 12,
		name: "武汉",
		code: 420100,
	},
	{
		id: 13,
		name: "温州",
		code: 330300,
	},
	{
		id: 14,
		name: "广州",
		code: 440100,
	},
	{
		id: 15,
		name: "长沙",
		code: 430100,
	},
	{
		id: 16,
		name: "桂林",
		code: 450330,
	},
	{
		id: 17,
		name: "昆明",
		code: 530100,
	},
	{
		id: 18,
		name: "南宁",
		code: 450100,
	},
	{
		id: 19,
		name: "无锡",
		code: 320200,
	},
];
var target = "";
function changecitycode(val) {
	async function citycodetoname() {
		axios({
			method: "GET",
			url: "/resource/city/code",
		}).then((res) => {
			cityDatalist = res.data;
		});
	}
	citycodetoname().then((e) => {
		if (val) {
			cityDatalist.forEach((item) => {
				if (item.code === val) {
					target = item.name;
				}
			});
		}
		return target;
	});
}
function citycodetoname() {
	axios({
		method: "GET",
		url: "/resource/city/code",
	}).then((res) => {
		cityDatalist = res.data;
	});
}
export default {
	citycodetoname,
	changecitycode,
};
